import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import UnStyledImage from "./image";

const Wrapper = styled.div.attrs(
  ({
    $align,
    $backgroundColor,
    $textColor,
    $verticalAlign,
    $mediaPosition,
    $imageFill,
  }) => ({
    $align: $align,
    $backgroundColor: $backgroundColor || "#fff",
    $textColor: $textColor || undefined,
    $verticalAlign: $verticalAlign,
    $mediaPosition: $mediaPosition,
    $imageFill: $imageFill,
  })
)`
  display: flex;
  flex-direction: ${({ $mediaPosition }) =>
    $mediaPosition === "left" ? "row" : "row-reverse"};
  background-color: ${({ $backgroundColor }) =>
    `var(--color-${$backgroundColor}, var(--color-white))`};
  color: ${({ $textColor }) =>
    `var(--color-${$textColor}, var(--color-black))`};
  align-items: ${({ $verticalAlign }) =>
    $verticalAlign === "top"
      ? "flex-start"
      : $verticalAlign === "bottom"
      ? "flex-end"
      : "center"};
  max-width: ${({ $align }) =>
    $align === "full" ? "100%" : $align === "wide" ? "1600px" : "1180px"};
  height: ${({ $imageFill }) => ($imageFill === true ? "40vh" : undefined)};
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-wrap: wrap;
    height: auto;
  }
`;

const Image = styled(UnStyledImage).attrs(({ $imageFill, $mediaWidth }) => ({
  $imageFill: $imageFill,
  $mediaWidth: $mediaWidth || "50%",
}))`
  flex-basis: ${({ $mediaWidth }) => `${$mediaWidth}%`};
  height: ${({ $imageFill }) => ($imageFill ? "inherit" : "auto")};
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-basis: 100%;
    height: ${({ $imageFill }) => ($imageFill ? "40vh" : "auto")};
  }
`;
const InnerBlock = styled.div.attrs(({ $mediaWidth }) => ({
  $contentWidth: $mediaWidth ? 100 - $mediaWidth : "50%",
}))`
  padding: clamp(0.525rem, 3vw, 1.6rem);
  flex-basis: ${({ $contentWidth }) => `${$contentWidth}%`};
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-basis: 100%;
  }
`;

const MediaText = ({
  align,
  backgroundColor,
  media,
  className,
  textColor,
  mediaWidth,
  mediaPosition,
  verticalAlignment,
  imageFill,
  children,
}) => {
  return (
    <Wrapper
      $align={align}
      $backgroundColor={backgroundColor}
      className={className}
      $textColor={textColor}
      $mediaPosition={mediaPosition}
      $verticalAlign={verticalAlignment}
      $imageFill={imageFill}
    >
      <Image image={media} $mediaWidth={mediaWidth} $imageFill={imageFill} />
      <InnerBlock $mediaWidth={mediaWidth}>{children}</InnerBlock>
    </Wrapper>
  );
};

MediaText.propTypes = {
  align: PropTypes.string,
  backgroundColor: PropTypes.string,
  media: PropTypes.object,
  className: PropTypes.string,
  textColor: PropTypes.string,
  imageFill: PropTypes.bool,
  mediaWidth: PropTypes.number,
  mediaPosition: PropTypes.string,
  verticalAlignment: PropTypes.string,
  children: PropTypes.node,
};

export default MediaText;
